// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"37ae0af2","72":"d3330773","477":"6e4cb0a7","627":"c1d887f2","663":"2ed1e379","667":"99a288c5","777":"c789e99c","803":"35b1f845","820":"07da189a"}[chunkId] + ".chunk.js";
};